import {FETCH_ALL, CREATE, UPDATE, DELETE} from '../constants/actionTypes'

const reducer = (posts = {}, action) => {
  switch (action.type) {
    case FETCH_ALL:
      return action.payload;
      
    case CREATE:
      return [...posts, action.payload];

    case UPDATE:              //Check what is the one post changed or liked 
      return posts.map((post)=> (post._id === action.payload._id ? action.payload : post));// return the post with change or return it as it was

    case DELETE:
      return posts.filter((post)=> post._id !== action.payload)//filtering out the one that we deleted

    default:
      return posts;
  }
};

export default reducer;
